/**
 * 需求2：https://www.tapd.cn/tapd_fe/34575918/story/detail/1134575918001289357
 *
 * 处理接口：get_piece_list、get_cart_price_list(V2支付页没有购物车，所以没有这个接口)
 *
 * 条件：
 * （1）只留下为true的渠道：(f_pay_type == router && （pay_type == jcb || pay_type == visa))
 * （2）生效时间：日本时间2025-08-22 17:00:00 - 不要时间判断了，直接下午4点发布
 * （3）只要地区选择了日本
 * （4）游戏id为：K1（285），蚂蚁（263），日本大掌柜（209），日本霸业（382），日本大千（337），侏罗纪（331），智城（175），PNS(191)
 */
const filterJpAreaPayType = (params, paytype_list) => {
  if (
    [285, 263, 209, 382, 337, 331, 175, 191].includes(Number(params?.gameId)) &&
    params?.location === 'JP'
  ) {
    return (
      paytype_list?.filter?.(item => {
        if (Number(params?.gameId) === 191) {
          return (
            (item?.f_pay_type === 'router' &&
              (item?.pay_type === 'jcb' || item?.pay_type === 'visa')) ||
            (item?.f_pay_type === 'user_balance_pay' &&
              item?.pay_type === 'user_balance_pay')
          );
        } else {
          return (
            item?.f_pay_type === 'router' &&
            (item?.pay_type === 'jcb' || item?.pay_type === 'visa')
          );
        }
      }) || []
    );
  } else {
    return paytype_list;
  }
};

/**
 * 需求：https://www.tapd.cn/tapd_fe/34575918/story/detail/1134575918001289496
 *
 * 处理接口（江美没有购物车）：https://jpstore.${window.atob('MzdnYW1lcy5jb20=')}/index/get_price_list_public
 *
 * 游戏：日本平台 江美 游戏id:2
 *
 * 只有日本平台有gmo渠道，日本平台没后台，需要特殊处理隐藏
 */
const filterGmoPayType = paytype_list => {
  if (window.isOfficialTopup) {
    return paytype_list?.filter?.(item => {
      return item?.f_pay_type !== 'gmo';
    });
  } else {
    return paytype_list;
  }
};

/**
 * 需求2：https://www.tapd.cn/tapd_fe/34575918/story/detail/1134575918001289357
 *
 * 对于日本平台的操作是：只保留world_pay父渠道，并且只保留JCB-SSL和VISA-SSL的子渠道支付方式
 *
 * 处理接口（江美没有购物车）：https://jpstore.${window.atob('MzdnYW1lcy5jb20=')}/index/get_price_list_public
 *
 * @param {*} params
 * @param {*} paytype_list
 * @returns
 */
const filterJpPlatformPayType = (params, paytype_list) => {
  if (
    window.isOfficialTopup &&
    Number(params?.gameId) === 2 &&
    params?.location === 'JP'
  ) {
    return paytype_list?.filter?.(item => {
      return (
        item?.f_pay_type === 'world_pay' &&
        (item?.pay_type === 'JCB-SSL' || item?.pay_type === 'VISA-SSL')
      );
    });
  } else {
    return paytype_list;
  }
};

/**
 * 2025-09-10
 * https://www.tapd.cn/tapd_fe/34575918/story/detail/1134575918001291601
 * 欧洲没有闪：非  英法德，不能使用以下渠道：
 * 父渠道 paypal_api
 * 子渠道 paypal_agreement 子渠道paypal_direct
 * @param {*} params
 * @param {*} paytype_list
 * @returns
 */

const filterPaypalPayType = (params, paytype_list) => {
  if (
    Number(params?.gameId) === 429 &&
    !['FR', 'DE', 'GB'].includes(params?.location)
  ) {
    return paytype_list?.filter?.(item => {
      if (
        item?.f_pay_type === 'paypal_api' &&
        ['paypal_agreement', 'paypal_direct'].includes(item?.pay_type)
      ) {
        return false;
      }
      return true;
    });
  }
  return paytype_list;
};

// 实际操作隐藏对应的渠道
export const filterPayType = (params, paytype_list) => {
  paytype_list = paytype_list || []; // 解决可能某些游戏某一些地区渠道为空的问题是null，在组件中访问时直接就【变量.length】了，相当于null.length
  paytype_list = filterJpAreaPayType(params, paytype_list);
  paytype_list = filterGmoPayType(paytype_list);
  paytype_list = filterJpPlatformPayType(params, paytype_list);
  paytype_list = filterPaypalPayType(params, paytype_list);
  return paytype_list;
};

// 针对V3.5支付页会在页面底部展示渠道图片轮播，隐藏一下对应的图标
export const filterPayTypeShow = (params, paytype_list) => {
  paytype_list = paytype_list || [];
  paytype_list = filterJpAreaPayType(params, paytype_list);
  paytype_list = filterPaypalPayType(params, paytype_list);
  return paytype_list;
};
